.button {
    display: flex;
    align-items: center;
    background-color: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
}

.content {
    max-width: 260px;
}
